/**
 * Hamper Build-a-Box ↔ physical box product pairing.
 * - When Appstle BAB (`_appstle-bb-id`) is added, also add the configured box product.
 * - Companion stays while any BAB content line remains; remove companion only
 *   after the last BAB content line is gone.
 * - Optional: hide qty / remove UI for the companion (Theme setting).
 */
(function () {
  if (window.__plantinHamperBoxPairBound) return;
  window.__plantinHamperBoxPairBound = true;

  var ENABLED = true;
  var BAB_ID = 'o95kvjgo';
  var COMPANION_VARIANT_ID = 50407743586338;
  var COMPANION_PRODUCT_ID = '';
  var COMPANION_HANDLE = 'hamoer-box';
  var HIDE_QTY = true;
  var PROP_COMPANION = '_plantin_hamper_companion';
  var PROP_BAB = '_plantin_hamper_bab_id';
  var APPSTLE_BAB_PROP = '_appstle-bb-id';
  var INTERNAL_HEADER = 'X-Plantin-Hamper-Pair';

  var syncing = false;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isInternal(init) {
    if (!init || !init.headers) return false;
    var headers = init.headers;
    if (typeof headers.get === 'function') return !!headers.get(INTERNAL_HEADER);
    if (Array.isArray(headers)) {
      return headers.some(function (pair) {
        return pair && String(pair[0]).toLowerCase() === INTERNAL_HEADER.toLowerCase();
      });
    }
    return !!(headers[INTERNAL_HEADER] || headers[INTERNAL_HEADER.toLowerCase()]);
  }

  function withInternal(init) {
    var next = Object.assign({}, init || {});
    var headers = new Headers(next.headers || {});
    headers.set(INTERNAL_HEADER, '1');
    if (!headers.has('Content-Type') && next.body && typeof next.body === 'string') {
      headers.set('Content-Type', 'application/json');
    }
    next.headers = headers;
    return next;
  }

  function parseJsonBody(body) {
    if (body == null) return null;
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        return null;
      }
    }
    if (
      typeof body === 'object' &&
      !(body instanceof FormData) &&
      !(typeof Blob !== 'undefined' && body instanceof Blob) &&
      !(typeof ArrayBuffer !== 'undefined' && body instanceof ArrayBuffer)
    ) {
      return body;
    }
    return null;
  }

  function stringifyBody(originalBody, payload) {
    if (typeof originalBody === 'string') return JSON.stringify(payload);
    return payload;
  }

  function itemProps(item) {
    return (item && item.properties) || {};
  }

  function isHamperBabItem(item) {
    return String(itemProps(item)[APPSTLE_BAB_PROP] || '') === BAB_ID;
  }

  function isPairedCompanion(item) {
    if (!item) return false;
    if (String(itemProps(item)[PROP_COMPANION] || '') === '1') return true;
    if (String(item.variant_id || item.id) === String(COMPANION_VARIANT_ID)) return true;
    if (COMPANION_HANDLE && item.handle === COMPANION_HANDLE) return true;
    if (COMPANION_PRODUCT_ID && String(item.product_id) === String(COMPANION_PRODUCT_ID)) return true;
    return false;
  }

  function injectCompanionIntoAddPayload(body) {
    if (!ENABLED || !COMPANION_VARIANT_ID) return body;

    var payload = parseJsonBody(body);
    if (!payload || !Array.isArray(payload.items)) return body;

    var hasHamper = payload.items.some(function (item) {
      return String((item.properties || {})[APPSTLE_BAB_PROP] || '') === BAB_ID;
    });
    if (!hasHamper) return body;

    var already = payload.items.some(function (item) {
      return String(item.id) === String(COMPANION_VARIANT_ID);
    });
    if (already) return body;

    var props = {};
    props[PROP_COMPANION] = '1';
    props[PROP_BAB] = BAB_ID;

    payload.items.push({
      id: COMPANION_VARIANT_ID,
      quantity: 1,
      properties: props,
    });

    return stringifyBody(body, payload);
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js', withInternal({ method: 'GET', credentials: 'same-origin' })).then(
      function (res) {
        if (!res.ok) throw new Error('cart.js ' + res.status);
        return res.json();
      }
    );
  }

  function applyUpdates(updates) {
    return fetch(
      cartRoot() + 'cart/update.js',
      withInternal({
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      })
    ).then(function (res) {
      return res.json().catch(function () {
        return null;
      });
    });
  }

  function refreshCartUi() {
    try {
      if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.setCart === 'function') {
        fetchCart().then(function (cart) {
          try {
            Rebuy.SmartCart.setCart(cart);
          } catch (e) {}
          lockCompanionQtyUi();
        });
      }
    } catch (e) {}

    document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true }));
    if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate && typeof window.publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'plantin-hamper-box-pair' });
    }
    lockCompanionQtyUi();
  }

  function findItemInCart(cart, idOrKeyOrLine) {
    if (!cart || !Array.isArray(cart.items) || idOrKeyOrLine == null) return null;
    if (typeof idOrKeyOrLine === 'object' && idOrKeyOrLine.line != null) {
      return cart.items[Number(idOrKeyOrLine.line) - 1] || null;
    }
    var id = String(idOrKeyOrLine);
    return (
      cart.items.find(function (item) {
        return item.key === id || String(item.variant_id) === id || String(item.id) === id;
      }) || null
    );
  }

  function companionKeysToClear(cart) {
    var updates = {};
    cart.items.forEach(function (item) {
      if (isPairedCompanion(item)) updates[item.key] = 0;
    });
    return updates;
  }

  function wasBabContentRemoval(preCart, payload, isChange, isUpdate) {
    if (!preCart || !payload) return false;

    if (isChange) {
      if (Number(payload.quantity) !== 0) return false;
      var trigger = findItemInCart(preCart, payload.id != null ? payload.id : { line: payload.line });
      return !!(trigger && isHamperBabItem(trigger));
    }

    if (isUpdate && payload.updates && typeof payload.updates === 'object') {
      return Object.keys(payload.updates).some(function (key) {
        if (Number(payload.updates[key]) !== 0) return false;
        var item = findItemInCart(preCart, key);
        return !!(item && isHamperBabItem(item));
      });
    }

    return false;
  }

  function isCompanionMutationBlocked(preCart, payload, isChange, isUpdate) {
    if (!HIDE_QTY || !preCart || !payload) return false;

    if (isChange) {
      var trigger = findItemInCart(preCart, payload.id != null ? payload.id : { line: payload.line });
      return !!(trigger && isPairedCompanion(trigger));
    }

    if (isUpdate && payload.updates && typeof payload.updates === 'object') {
      return Object.keys(payload.updates).some(function (key) {
        var item = findItemInCart(preCart, key);
        if (!item || !isPairedCompanion(item)) return false;
        return Number(payload.updates[key]) !== Number(item.quantity);
      });
    }

    return false;
  }

  // Only drop the physical box after the last hamper content line is gone.
  function clearCompanionIfNoBabLeft(preCart, payload, isChange, isUpdate) {
    if (!wasBabContentRemoval(preCart, payload, isChange, isUpdate)) {
      return Promise.resolve(false);
    }

    return fetchCart().then(function (cartAfter) {
      var babLeft = cartAfter.items.some(isHamperBabItem);
      if (babLeft) return false;

      var updates = companionKeysToClear(cartAfter);
      if (!Object.keys(updates).length) return false;

      syncing = true;
      return applyUpdates(updates)
        .then(function () {
          refreshCartUi();
          return true;
        })
        .finally(function () {
          syncing = false;
        });
    });
  }

  function handleCartMutation(url, init, originalFetch, input) {
    var payload = parseJsonBody(init && init.body);
    var isChange = /\/cart\/change(\.js)?(\?|$)/i.test(url);
    var isUpdate = /\/cart\/update(\.js)?(\?|$)/i.test(url);

    if (!payload || syncing) {
      return originalFetch(input, init);
    }

    return fetchCart()
      .then(function (preCart) {
        if (isCompanionMutationBlocked(preCart, payload, isChange, isUpdate)) {
          return Promise.resolve(
            new Response(JSON.stringify(preCart), {
              status: 200,
              headers: { 'Content-Type': 'application/json' },
            })
          );
        }

        return originalFetch(input, init).then(function (response) {
          if (!response || !response.ok) return response;
          return clearCompanionIfNoBabLeft(preCart, payload, isChange, isUpdate)
            .catch(function () {
              return false;
            })
            .then(function () {
              return response;
            });
        });
      })
      .catch(function () {
        return originalFetch(input, init);
      });
  }

  function injectHideQtyStyles() {
    if (!HIDE_QTY || document.getElementById('plantin-hamper-companion-qty-style')) return;
    var style = document.createElement('style');
    style.id = 'plantin-hamper-companion-qty-style';
    style.textContent =
      '.rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] .rebuy-cart__flyout-item-quantity,' +
      '.rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] .rebuy-cart__flyout-item-remove,' +
      '.rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] .rebuy-cart__flyout-item-remove-button,' +
      '.rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] [class*="quantity"],' +
      '.rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] [class*="remove"]{' +
      'display:none!important;}' +
      '.rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] a{' +
      'pointer-events:none!important;cursor:default!important;text-decoration:none!important;}' +
      '.cart-item--hamper-companion quantity-input,' +
      '.cart-item--hamper-companion cart-remove-button,' +
      '.cart-item--hamper-companion .quantity-popover-container,' +
      '.cart-item--hamper-companion .cart-item__link{' +
      'display:none!important;}' +
      '.cart-item--hamper-companion .cart-item__name{' +
      'pointer-events:none;cursor:default;text-decoration:none;}';
    document.head.appendChild(style);
  }

  function lockCompanionQtyUi() {
    if (!HIDE_QTY) return;
    injectHideQtyStyles();

    fetchCart()
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var companionKeys = {};
        var companionVariantIds = {};
        var companionHandles = {};

        cart.items.forEach(function (item) {
          if (!isPairedCompanion(item)) return;
          companionKeys[item.key] = true;
          companionVariantIds[String(item.variant_id)] = true;
          if (item.handle) companionHandles[item.handle] = true;
        });

        document.querySelectorAll('.rebuy-cart__flyout-item').forEach(function (el) {
          var key = el.getAttribute('data-item-key') || el.getAttribute('data-key') || '';
          var variantAttr =
            el.getAttribute('data-variant-id') ||
            el.getAttribute('data-product-variant-id') ||
            '';
          var link = el.querySelector('a[href*="/products/"]');
          var href = link ? link.getAttribute('href') || '' : '';
          var handleMatch = href.match(/\/products\/([^\/?#]+)/);
          var handle = handleMatch ? handleMatch[1] : '';
          var variantMatch = href.match(/[?&]variant=(\d+)/);
          var variantFromHref = variantMatch ? variantMatch[1] : '';

          var matched =
            (key && companionKeys[key]) ||
            (variantAttr && companionVariantIds[String(variantAttr)]) ||
            (variantFromHref && companionVariantIds[variantFromHref]) ||
            (handle && companionHandles[handle]) ||
            (COMPANION_HANDLE && handle === COMPANION_HANDLE);

          if (matched) {
            el.setAttribute('data-plantin-hamper-companion', '1');
            el.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
              if (link.getAttribute('data-plantin-hamper-unlinked') === '1') return;
              link.setAttribute('data-plantin-hamper-unlinked', '1');
              link.setAttribute('data-href', link.getAttribute('href') || '');
              link.removeAttribute('href');
              link.setAttribute('role', 'text');
              link.setAttribute('tabindex', '-1');
            });
          } else {
            el.removeAttribute('data-plantin-hamper-companion');
          }
        });

        document.querySelectorAll('.cart-item').forEach(function (el) {
          var input = el.querySelector('[data-quantity-variant-id], [data-quantity-line-key]');
          var variantId = input && input.getAttribute('data-quantity-variant-id');
          var lineKey = input && input.getAttribute('data-quantity-line-key');
          var matched =
            el.getAttribute('data-plantin-hamper-companion') === '1' ||
            (lineKey && companionKeys[lineKey]) ||
            (variantId && companionVariantIds[String(variantId)]);
          if (matched) {
            el.classList.add('cart-item--hamper-companion');
            el.setAttribute('data-plantin-hamper-companion', '1');
            el.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
              if (link.getAttribute('data-plantin-hamper-unlinked') === '1') return;
              link.setAttribute('data-plantin-hamper-unlinked', '1');
              link.setAttribute('data-href', link.getAttribute('href') || '');
              link.removeAttribute('href');
              link.setAttribute('role', 'text');
              link.setAttribute('tabindex', '-1');
            });
          }
        });
      })
      .catch(function () {});
  }

  function bindQtyUiLocks() {
    if (!HIDE_QTY || window.__plantinHamperQtyUiBound) return;
    window.__plantinHamperQtyUiBound = true;

    [
      'rebuy:cart.change',
      'rebuy:cart.add',
      'rebuy:cart.remove',
      'rebuy:smartcart.ready',
      'rebuy:cart.ready',
      'rebuy:smartcart.show',
      'rebuy:smartcart.opened',
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        lockCompanionQtyUi();
      });
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (
        target.closest(
          '.rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] [class*="quantity"], .rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] [class*="remove"], .rebuy-cart__flyout-item[data-plantin-hamper-companion="1"] a, .cart-item--hamper-companion a'
        )
      ) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    lockCompanionQtyUi();
  }

  function hookFetch() {
    if (typeof window.fetch !== 'function' || window.__plantinHamperBoxPairFetchHooked) return;
    window.__plantinHamperBoxPairFetchHooked = true;

    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = requestUrl(input);
      init = init || {};

      if (isInternal(init)) {
        return originalFetch(input, init);
      }

      if (!ENABLED) {
        return originalFetch(input, init);
      }

      if (/\/cart\/add(\.js)?(\?|$)/i.test(url) && init.body != null) {
        return originalFetch(
          input,
          Object.assign({}, init, {
            body: injectCompanionIntoAddPayload(init.body),
          })
        ).then(function (response) {
          lockCompanionQtyUi();
          return response;
        });
      }

      if (/\/cart\/(change|update)(\.js)?(\?|$)/i.test(url)) {
        return handleCartMutation(url, init, originalFetch, input).then(function (response) {
          lockCompanionQtyUi();
          return response;
        });
      }

      return originalFetch(input, init);
    };
  }

  function applyConfigFromElement(el) {
    if (!el) return;
    var enabled = el.getAttribute('data-enabled');
    if (enabled != null) ENABLED = enabled !== 'false';

    var bab = el.getAttribute('data-bab-id');
    var variant = el.getAttribute('data-companion-variant-id');
    var productId = el.getAttribute('data-companion-product-id');
    var handle = el.getAttribute('data-companion-handle');
    var hideQty = el.getAttribute('data-hide-qty');

    if (bab) BAB_ID = bab;
    if (variant) COMPANION_VARIANT_ID = Number(variant) || COMPANION_VARIANT_ID;
    if (productId) COMPANION_PRODUCT_ID = String(productId);
    if (handle) COMPANION_HANDLE = handle;
    if (hideQty != null) HIDE_QTY = hideQty !== 'false';
  }

  class PlantinHamperBoxPair extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      applyConfigFromElement(this);
      if (!ENABLED || !COMPANION_VARIANT_ID) return;

      hookFetch();
      bindQtyUiLocks();
    }
  }

  if (!customElements.get('plantin-hamper-box-pair')) {
    customElements.define('plantin-hamper-box-pair', PlantinHamperBoxPair);
  }

  function boot() {
    var el = document.querySelector('plantin-hamper-box-pair');
    if (el) {
      applyConfigFromElement(el);
      if (ENABLED && COMPANION_VARIANT_ID) {
        hookFetch();
        bindQtyUiLocks();
      }
      return;
    }
    // No Liquid bootstrap — pairing disabled via theme settings.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
